// extracted by mini-css-extract-plugin
module.exports = {"root":"PageBlok_root__P4lJh"};